export const getValidPropertiesFromObject = (object: Record<string, unknown>, validProperties: Set<string>) => {
    const validObject = {};

    for (const validProperty of validProperties) {
        validObject[validProperty] = object[validProperty];
    }

    return validObject;
};
